<main class="policy-shell">
  <section class="policy-container">
    <header class="policy-header">
      <div>
        <p class="eyebrow">{{ 'common.ssoBrand' | translate }}</p>
        <h1>{{ 'privacyPolicy.title' | translate }}</h1>
        @if (consent(); as signed) {
          @if (signed.signedBy) {
            <p class="subtitle">
              {{ 'privacyPolicy.signedBy' | translate }}:
              <strong>{{ signed.signedBy }}</strong>
            </p>
          }
          @if (signed.signedAt) {
            <p class="subtitle signed-at">
              {{ 'privacyPolicy.signedAt' | translate }}:
              <strong>{{ signed.signedAt | date: 'dd.MM.yyyy HH:mm' }}</strong>
            </p>
          }
        }
      </div>
      <a nz-button routerLink="/main">{{ 'common.backToModules' | translate }}</a>
    </header>

    <nz-card class="policy-card">
      <app-consent-view/>
    </nz-card>
  </section>
</main>
